import { useEffect, useState } from "react";
import {
  usePosVsShippedDropDownFilterMutation,
  useGetPosVsShippedDataMutation,
} from "../api/posVsShippedApi";

export const usePosVsShippedDropDownFilter = () => {
  const [mutate, { isLoading, isSuccess, isError, error, data }] =
    usePosVsShippedDropDownFilterMutation();
  return {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export const useGetPosVsShippedData = () => {
  const [localData, setLocalData] = useState(undefined);
  const [mutate, { isLoading, isSuccess, isError, error, data }] =
    useGetPosVsShippedDataMutation();

  // Reset function to clear the local data
  const resetData = () => {
    setLocalData(undefined);
  };

  // Sync local data with API data when the mutation succeeds
  useEffect(() => {
    if (isSuccess) {
      setLocalData(data?.data);
    }
  }, [isSuccess]);

  return {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data: localData, // Use local data instead of API data
    resetData,
  };
};
